/*
https://pan.hzdatalink.com/api/alien/download/3386c048-551b-464c-64e0-347d1d3df742/测试文件.xlsx
https://pan.hzdatalink.com/api/alien/download/5a2d11e8-29aa-4e0d-76cb-d4926c9fb16e/测试文件.docx
*/

import devHelper from '../../util/devHelper'
import dbHelper from '../../util/db'
import functions from '../../functions'
import msgbus from '../../msgBus'
import i18n from '../../lang/index'


const g_edsDownloadFileDir = 'edsDownloadFiles'  // edsAPP存放下载文件的目录名:APP目录/files/edsDownloadFiles/ + msgbus.vm.getAccountID()

// 异步检查存储权限
function asyncCheckStoragePermission() {
  return new Promise((resolve, reject) => {
    if (msgbus.vm.getPlatform() == 'Android') {
      window.cordova.plugins.gsfileview.CallFunction(
        false,
        'CheckPermission',
        function (hasPermission) {
          if (!hasPermission) {
            msgbus.vm.setRequestStorage({
              value: {
                visible: true,
                callback: function (grant) {
                  if (grant) {
                    window.cordova.plugins.gsfileview.CallFunction(
                      grant,
                      'CheckPermission',
                      function (granted) {
                        resolve(granted)
                      },
                      function (error) {
                        reject(error)
                      }
                    )
                  } else {
                    resolve(false)
                  }
                }
              }
            })
          } else {
            resolve(true)
          }
        },
        function (error) {
          if (((typeof error === 'object' && error.message) || error) === 'cordova组件接口中没有定义指定的action操作。') { // 兼容1.0.17.44等旧壳
            resolve(true)
          } else {
            reject(error)
          }
        }
      )
    } else {
      resolve(true)
    }
  })
}

var edsdownloadfileHelper = {


  // isOpenFile 标记下载完成后，是否打开文件，1 下载并打开文件；0 只下载
  funcEdsDownloadFile(isOpenFile, fileInfo) {
    if (msgbus.vm.getPlatform() === 'Android') {
      asyncCheckStoragePermission().then(hasPermission => {
        if (hasPermission) {
          // 下载文件
          functions.edsdownloadfileHelper.edsDownloadFile(isOpenFile, fileInfo)
        } else {
          // 置正在下载标记false
          msgbus.vm.setIsDownloading({ value: false })
        }
      }).catch(error => {
        const message = (typeof error === 'object' && error.message) || error
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: message,
            visible: true
          }
        })
      })
    } else if (msgbus.vm.getPlatform() === 'iOS') {
      functions.edsdownloadfileHelper.edsDownloadFile(isOpenFile, fileInfo)
    }
  },
  // isOpenFile 标记下载完成后，是否打开文件，1 下载并打开文件；0 只下载
  edsDownloadFile(isOpenFile, fileInfo) {
    console.log('调试代码')
    // alert('fileInfo' +  + JSON.stringify(fileInfo))
    if (msgbus.vm.getPlatform() === 'Android') {
      window.resolveLocalFileSystemURL(
        window.cordova.file.externalDataDirectory,
        function (dirEntry) { // 读取目录： files
          dirEntry.getDirectory( // 读取目录：files/edsDownloadFiles 如果目录不存在，则创建edsFiles命名的子目录
            g_edsDownloadFileDir,
            { create: true },
            function (subDirEntry) { // 回调
              subDirEntry.getDirectory( // 读取目录：files/edsDownloadFiles/账号ID 如果目录不存在，则创建以“账号ID”命名的子目录
                msgbus.vm.getAccountID(),
                { create: true },
                function (subAccountDirEntry) { // 回调
                  // alert('functions.edsdownloadfileHelper.downloadFile')
                  functions.edsdownloadfileHelper.downloadFile(isOpenFile, fileInfo, subAccountDirEntry, 2)
                },
                function (error) {// 置正在下载标记false
                  msgbus.vm.setIsDownloading({ value: false })
                })
            },
            function (error) {// 置正在下载标记false
              msgbus.vm.setIsDownloading({ value: false })
            })
        },
        function (error) {// 置正在下载标记false
          msgbus.vm.setIsDownloading({ value: false })
        })
    } else {
      window.resolveLocalFileSystemURL(
        window.cordova.file.documentsDirectory,
        function (dirEntry) { // 读取目录： files
          dirEntry.getDirectory( // 读取目录：files/edsDownloadFiles 如果目录不存在，则创建edsFiles命名的子目录
            g_edsDownloadFileDir,
            { create: true },
            function (subDirEntry) { // 回调
              subDirEntry.getDirectory( // 读取目录：files/edsDownloadFiles/账号ID 如果目录不存在，则创建以“账号ID”命名的子目录
                msgbus.vm.getAccountID(),
                { create: true },
                function (subAccountDirEntry) { // 回调
                  // alert('functions.edsdownloadfileHelper.downloadFile')
                  functions.edsdownloadfileHelper.downloadFile(isOpenFile, fileInfo, subAccountDirEntry, 2)
                },
                function (error) {// 置正在下载标记false
                  msgbus.vm.setIsDownloading({ value: false })
                })
            },
            function (error) {// 置正在下载标记false
              msgbus.vm.setIsDownloading({ value: false })
            })
        },
        function (error) {// 置正在下载标记false
          msgbus.vm.setIsDownloading({ value: false })
        })
    }
  },

  downloadFile(isOpenFile, fileInfo, dirEntry, maxRetry = 0, currentRetry = 0) {
    var finalPath = dirEntry.nativeURL + fileInfo.fileName
    // alert('download ' + finalPath)
    fileInfo.fileWholeName = finalPath.substring(7) // 转换gsfileview要求的文件格式，即去除file://

    // 使用fileTransfer.download开始下载
    var fileTransfer = new window.FileTransfer()
    fileTransfer.download(
      encodeURI(fileInfo.flowFileURL), //uri网络下载路径
      finalPath, //文件本地存储路径
      function (entry) {
        // alert('download success' + fileWholeName)
        // 读取文件信息并写Sqlite数据库打开文件信息
        functions.edsfileview.funcGetFileInfo(fileInfo, isOpenFile)
        // 置正在下载标记false
        msgbus.vm.setIsDownloading({ value: false })
      },
      function (error) {
        if (devHelper.isDevMode()) { // 判断是否开启了测试模式)
          alert(JSON.stringify(error))
        }
        if (currentRetry < maxRetry) {
          setTimeout(() => {
            functions.edsdownloadfileHelper.downloadFile(isOpenFile, fileInfo, dirEntry, maxRetry, currentRetry + 1)
          }, 3000)
        } else {
          msgbus.vm.setSnackBar({
            value: {
              color: 'error',
              text: i18n.t('文件[{name}] 下载失败，请稍后再试。', { name: fileInfo.flowFileName }),
              visible: true
            }
          })
          // 置正在下载标记false
          msgbus.vm.setIsDownloading({ value: false })
        }
      }
    )
  }
}
export default edsdownloadfileHelper
